import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { TasksScreen } from '../components/tasks/TasksScreen';
import { useInEventWorkspace } from '../components/events/workspace/EventWorkspaceContext';

/**
 * Tasks — an event's (its Tasks tab, `/events/:eventId/checklist`) or every
 * event's (`/tasks`, and the older `/checklists`). Outside the event
 * workspace an event's tasks keep a way back to the event.
 */
export function TaskListPage() {
  const { eventId } = useParams<{ eventId: string }>();
  const inWorkspace = useInEventWorkspace();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // `?templates=1`: the checklist templates, where their tasks are edited —
  // reached from the Templates page's "Edit tasks".
  const templates = !eventId && searchParams.get('templates') === '1';

  return (
    <TasksScreen
      eventId={eventId}
      templates={templates}
      leading={
        eventId && !inWorkspace ? (
          <button
            type="button"
            onClick={() => navigate(`/events/${eventId}`)}
            className="flex items-center gap-1 text-sm text-gray-500 hover:text-primary-600 transition-colors"
            aria-label="Back to event"
          >
            <ArrowLeft size={16} />
            <span className="hidden sm:inline">Back to Event</span>
          </button>
        ) : undefined
      }
    />
  );
}
